import React from 'react'
import { FormattedMessage } from 'react-intl'

import './LiveNow.scss'

const LiveNow = () => (
  <span className="live-now">
    <FormattedMessage defaultMessage="Live now" />
  </span>
)

export default LiveNow
